// extracted by mini-css-extract-plugin
export default {"status":"LxkVx","success":"TGfGw","fail":"hX1Y3"};